/**
 * Phone number formatting utilities
 */

import { PHONE_NUMBER } from '../../config/constants';

/**
 * Format phone number to Korean standard (000-0000-0000 or 000-000-0000)
 * @param phoneNumber - Raw phone number string
 * @returns Formatted phone number or '-' if empty
 *
 * @example
 * formatPhoneNumber('01012345678') // '010-1234-5678'
 * formatPhoneNumber('0212345678') // '02-1234-5678'
 * formatPhoneNumber('') // '-'
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '-';

  const numbers = phoneNumber.replace(/[^0-9]/g, '');

  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 7) {
    return `${numbers.slice(0, 3)}${PHONE_NUMBER.DISPLAY_SEPARATOR}${numbers.slice(3)}`;
  }

  return `${numbers.slice(0, 3)}${PHONE_NUMBER.DISPLAY_SEPARATOR}${numbers.slice(3, 7)}${PHONE_NUMBER.DISPLAY_SEPARATOR}${numbers.slice(7, 11)}`;
};

/**
 * Validate phone number format
 * @param phoneNumber - Phone number to validate
 * @returns true if valid Korean phone number format
 */
export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const numbers = phoneNumber.replace(/[^0-9]/g, '');
  return numbers.length >= PHONE_NUMBER.MIN_LENGTH && numbers.length <= PHONE_NUMBER.MAX_LENGTH;
};

/**
 * Strip formatting from phone number
 * @param phoneNumber - Formatted phone number
 * @returns Raw number string
 */
export const stripPhoneNumberFormatting = (phoneNumber: string): string => {
  return phoneNumber.replace(/[^0-9]/g, '');
};
